module.exports = __webpack_public_path__ + "img/gongnneg_img.82c19610.png";